import { useI18n } from 'next-localization';
import BaseSkeleton from 'components/Generic/BaseSkeleton';

type DisplayingRangeProps = {
  dictionaryKey: string;
  page: number;
  take: number;
  total: number;
  showSkeleton?: boolean;
  className?: string;
};

const DisplayingRange = ({
  dictionaryKey = 'paginationDisplayingResults',
  page,
  take,
  total,
  showSkeleton,
  className = '',
}: DisplayingRangeProps) => {
  const { t } = useI18n();

  const from: number = total === 0 ? 0 : (page - 1) * take + 1;
  const to: number = Math.min(page * take, total);

  return (
    <p className={`footnote text-grey ${className}`}>
      {!showSkeleton ? (
        <>
          {t(dictionaryKey)
            .replace('{token.range}', `${from} - ${to}`)
            .replace('{token.total}', `${total}`)}
        </>
      ) : (
        <BaseSkeleton width="220px" className="d-block" />
      )}
    </p>
  );
};

export default DisplayingRange;
